import React from 'react';
import moment from 'moment';
import { CustomDialog, Timeline, TimelineItem } from '../../custom-forms';
import { useAppSelector } from '../../store/configureStore';
import { useTranslate } from '../../hooks/useTranslate';
import { OrderPartDeliveryDateHistory } from '../../interfaces/Order';

export interface DeliveryDateHistoryDialogProps {
  open: boolean;
  items: OrderPartDeliveryDateHistory[];
  onClose: () => void;
}

const DeliveryDateHistoryDialog: React.FC<DeliveryDateHistoryDialogProps> = ({
  open,
  items,
  onClose
}) => {
  const t = useTranslate();
  const longDateFormat = useAppSelector((s) => s.app!.longDateFormat);

  const formatDeliveryDate = (date: string | null): string => {
    if (!date) return '';
    return moment(date).format(longDateFormat).replace(/ 00:00(:00)?$/, '');
  };

  const timelineItems: TimelineItem[] = items.map((row) => ({
    title: formatDeliveryDate(row.deliveryDate),
    subtitle: `${row.dateCreation ? moment.utc(row.dateCreation).local().format(longDateFormat) : ''}${
      row.createdByEmail ? ' (' + row.createdByEmail + ')' : ''
    }`,
    content: `${t('ORDER_PART_HISTORY_DAYS_ADDED', 'Zile adaugate')}: ${row.extensionDaysAdded ?? 'N/A'}`
  }));

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      onConfirm={onClose}
      maxWidth="md"
      title={t('ORDER_PART_DELIVERY_HISTORY_LABEL', 'Istoric livrare')}
      cancelLabel={t('CLOSE', 'Inchide')}
      confirmLabel={t('CLOSE', 'Inchide')}
      hideActions
    >
      <Timeline
        items={timelineItems}
        emptyLabel={t('ORDER_DETAILS_HISTORY_NO_DATA', 'Nu exista date de afisat!')}
      />
    </CustomDialog>
  );
};

export default DeliveryDateHistoryDialog;
